export const IDENTITY_EVENT_TYPES: string[] = [
    'oidc_session.added',
    'user.human.signed.out',
    'user.grant.added',
    'user.grant.removed',
    'org.member.added',
];

export const APPLICATION_EVENT_TYPES: string[] = [
    'user.login',
    'user.logout',
    'source.create',
    'source.delete',
    'source.download',
    'query.execute',
    'events.export',
    'alert_rule.create',
    'alert_rule.update',
    'alert_rule.delete',
    'person.create',
    'person.update',
    'person.delete',
    'person.merge',
    'person.groups.assign',
    'person.group.remove',
    'person.event.link',
    'person.event.unlink',
    'person.profile_picture.added',
    'person.profile_picture.replaced',
    'person.profile_picture.removed',
    'vehicle.create',
    'vehicle.update',
    'vehicle.delete',
    'vehicle.merge',
    'vehicle.event.link',
    'vehicle.event.unlink',
    'report.create',
    'report.update',
    'report.delete',
    'report.export',
    'organization_configuration.update',
    'user.add_blocked',
    'camera.add_blocked',
];
